import { getQueryString } from "./index";

export default function bread(pageId, level = 1, name, obj) {
  let l = ''
  let id = getQueryString('id')
  if (pageId == 1) { //自检列表
    l = [{
      path: '/SelfCheckList',
      name: '自检列表'
    }]
    if (level == 2) {
      l.push({
        name: name
      })
    }
  } else if (pageId == 2) {//审核
    l = [{
      path: '',
      name: name
    }]
    if (level == 2) {
      l = [{
        path: '/examine/projectList',
        name: '项目列表'
      }]
      l.push({
        name: name
      })
    }
  } else if (pageId == 3) {//培训
    l = [{
      path: '',
      name: name
    }]

  } else if (pageId == 4) {//培训
    l = [{
      path: '',
      name: name
    }]
    if (level >= 1) {
      l = [{
        path: '/training/training',
        name: '培训列表'
      }]
      if (level == 2) {
        l.push({
          name: name
        })
      } else {
        l = [...l, ...obj]
      }

    }
  }

  return l;
}